import { render, staticRenderFns } from "./IndustriesPage.vue?vue&type=template&id=4d75fbfd&lang=pug&"
import script from "./IndustriesPage.vue?vue&type=script&lang=js&"
export * from "./IndustriesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports